import { render, staticRenderFns } from "./SumOrders.vue?vue&type=template&id=35effc13"
import script from "./SumOrders.vue?vue&type=script&lang=js"
export * from "./SumOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports